"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationCartLink = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const bs_1 = require("react-icons/bs");
function NavigationCartLink(_a) {
    var { className, cartCount, cartHref } = _a, props = __rest(_a, ["className", "cartCount", "cartHref"]);
    return (react_1.default.createElement("a", Object.assign({ href: "/checkout/shopping-cart", className: (0, classnames_1.default)('relative text-gray-74 hover:text-gray transition-colors solid-focus-ring', className) }, props),
        react_1.default.createElement(bs_1.BsCart3, { size: "30px" }),
        cartCount && (react_1.default.createElement("span", { className: "absolute -top-1 -right-1 bg-blue-hover rounded-full px-[0.3rem] text-xs text-white text-center" }, cartCount))));
}
exports.NavigationCartLink = NavigationCartLink;
